// extracted by mini-css-extract-plugin
var _1 = "BirdviewControlOption-moduleactive__B_U0Q";
var _2 = "BirdviewControlOption-moduleoption__Zubmf";
export { _1 as "active", _2 as "option" }
